
import {
Component,
Vue,
Inject,
Prop,
Watch,
} from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase';
import PageRequest from '@/store/entities/page-request';
@Component({})
export default class vIcon extends AbpBase {
//父子传值
 @Prop({
type: String,
default: 'fa fa-align-justify'
}) name: boolean;
@Prop({
type: String,
default: 'white'
}) colors: string;
@Prop({
type: String,
default: 'cursor'
}) cursor: string
@Prop({
type: Number,
default: 20
}) size: number
//数据
//计算属性
//方法
clickIcon(){
  this.$emit('clickIcon')
}
//钩子函数
};
